import { useEffect, useState } from "react"

export interface EncodeProgress {
  videoId: number
  resolution: string
  percent: number
  done: boolean
  error: boolean
}

export const useEncodeProgress = (
  videoId: number,
  enabled: boolean,
  onFinish?: () => void,
) => {
  const [progress, setProgress] = useState<EncodeProgress | null>(null)

  useEffect(() => {
    if (!enabled) return
    const protocol = window.location.protocol === "https:" ? "wss" : "ws"
    const socket = new WebSocket(
      `${protocol}://${window.location.host}/api/ws/encode/${videoId}`,
    )
    socket.onmessage = (event) => {
      const data: EncodeProgress = JSON.parse(event.data)
      setProgress(data)
      if (data.done || data.error) onFinish?.()
    }
    return () => socket.close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId, enabled])

  return progress
}
